import { render, staticRenderFns } from "./TheAppList.vue?vue&type=template&id=5202b50e&"
import script from "./TheAppList.vue?vue&type=script&lang=js&"
export * from "./TheAppList.vue?vue&type=script&lang=js&"
import style0 from "./TheAppList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports